import { Icon } from "@iconify/react/dist/iconify.js";
const TableDataNoAvailable = ({ message }) => {
  return (
    <div className="text-center p-4">
      <Icon
        icon="mdi:account-group-outline"
        className="text-muted mb-3"
        style={{ fontSize: "48px" }}
      />
      <p>{message}</p>
      <button
        className="btn btn-outline-primary-600 btn-sm"
        onClick={() => window.location.reload()}
      >
        Refresh
      </button>
    </div>
  );
};
export default TableDataNoAvailable;